/**
 * Converts the provided object to URL search params (treating it as key-value pairs).
 * @param params The values to add together as URL params.
 * @returns A query string made up of the provided params.
 */
export function generateQueryString(params: Record<string, undefined | number | string>): string {
  return new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined)) as Record<string, string>
  ).toString();
}
